<template>
  <div id="secure">
    <div id="patient-header">
      <div id="patient-header-outer" class="edith-bg-medium">
        <div id="patient-header-left">
          <img src="../assets/Edith.png" alt="Edith Logo" height="120px" width="180px"/>
        </div>
        <div id="logout-timer-header-patient">
          <p class="text-center" style="color: red">EDUCATION and RESEARCH ONLY! <br><span style="color: black">Es ist keine Verwendung in der Patientenversorgung erlaubt.
            Die Wissensbasis wird nicht aktualisiert!</span> </p>
        </div>
      </div>
    </div>
    <div id="patient-body" :style="`height: ${cssHeightOfBody};`">
      <div>
        <PatientFormular @showCdss="(patientData) => $emit('showCdss', patientData)"/>
      </div>
    </div>
    <div id="patient-footer" class="edith-bg-medium">
      <div id="version-number"><span>Version  {{ $store.getters.appVersion }}</span>
        <b-icon-dash-lg rotate="90" style="color:rgb(179 188 194)"/>
        <span><a href="https://www.ukaachen.de/impressum/" target="_blank">Impressum</a></span></div>
    </div>
  </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import PatientFormular from "./PatientFormular.vue";

export default {
  name: 'Secure',
  components: {PatientFormular},
  emits: {
    showCdss: null,
  },
  data() {
    return {
      input: {
        filetext: ''
      },
      showEdit: true,
      editablePatient: null,
      username: null,
      remainingMillis: Date.now(),
      buttonClass: 'light',
      alertClass: 'alert-light',
      shownRemainingTime: undefined,
      directLogout: false,
      cssHeightOfBody: 0
    };
  },
  mounted() {
    window.addEventListener('resize', this.cssTrickSetHeight)
    this.cssTrickSetHeight()
  },
  methods: {
    cssTrickSetHeight() {
      // complete window minus the header height
      this.cssHeightOfBody = window.innerHeight - 170 + 'px';
    }
  }
}
</script>

<style scoped>
#secure {
  display: grid;
  grid-template-columns: 1fr;
  grid-template-areas: "header" "body" "footer";
  grid-template-rows: 120px 1fr 50px;
}

#patient-header {
  grid-area: header;
  overflow: hidden;
  height: 120px;
  position: sticky;
  z-index: 5;
}

#patient-body {
  margin-left: 20px;
  margin-right: 20px;
  grid-area: body;
  overflow: auto;
  display: grid;
  grid-template-rows: 1fr;
}

#patient-header-outer {
  display: grid;
  width: 100%;
  grid-template-areas: "logo logout-timer logout-button";
  grid-template-columns: 1fr 300px 1fr;
  grid-row: 1;
  position: fixed;
  z-index: 9999999;
}

#patient-header-left {
  grid-area: logo;
}

#logout-timer-header-patient {
  grid-area: logout-timer;
  display: grid;
  grid-template-areas: "logout-timer-label logout-timer-button";
  grid-template-columns: 1fr min-content;
  align-self: center;

  justify-items: center;
  align-items: center;
}

#logout-timer-label-patient {
  grid-area: logout-timer-label;
  align-self: center;
  color: black;
}

#logout-timer-button-patient {
  grid-area: logout-timer-button;
  align-self: center;
}

#patient-header-right {
  grid-area: logout-button;
  justify-self: end;
  align-self: center;
  grid-template-areas: "patient-logout-label patient-logout-button";
  grid-template-columns: 1fr 80px;
  display: grid;
}

#label-username-patient-header {
  grid-area: patient-logout-label;
  align-self: center;
  margin-right: 10px;
}

#button-logout-patient-header {
  grid-area: patient-logout-button;
}

#patient-footer {
  grid-area: footer;
  overflow: hidden;
}

#version-number {
  grid-area: center;
  text-align: center;
  justify-content: center;
  color: #5a6268;
  padding-top: 10px;
}

</style>
